/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import Amend from 'SVGPath/reschedule.svg'
import ETicket from 'SVGPath/e-ticket.svg'
import Refund from 'SVGPath/check-refund.svg'
import Cancel from 'SVGPath/cancel.svg'
import Invoice from 'SVGPath/invoice.svg'

import { getCancellationLink, getAmendmentLink, isIosApp, isMobileApp, isAndroidApp, getQueryParams, isWebView } from 'AccountsUtils'
import { getCookie } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'
import { getMappedValue } from '../../utils/arabicUtils'
import ToolItem from './ToolItem'
import CancellationBlockModal from '../CancellationBlockModal'
import { CANCELLATION_TEMPORARILY_DISABLED } from '../../constants/app'

const ToolList = ({
  tripOptions,
  vasOpted,
  tripId,
  isPWA,
  abData,
  tripDetails,
  domain
}) => {
  // Hide only options that navigate to cancellation/refund/reschedule. Keep 'cancellable' (modal) visible.
  const optionsThatNavigateToCancellation = ['refundable', 'amendable']
  const isOptionHiddenByTemporaryDisable = option =>
    CANCELLATION_TEMPORARILY_DISABLED && optionsThatNavigateToCancellation.includes(option)

  let key = Object.keys(tripOptions)
  const keys = Object.keys(tripOptions)
  const params = getQueryParams()
  let n = keys.length
  const newobj = {}
  while (n > 0) {
    n -= 1
    key = keys[n]
    newobj[key.toLowerCase()] = tripOptions[key]
  }
  const [vas, setVas] = useState(null)
  const isRTL = getCookie('selectedLanguage') === 'ar'

  const toolOrder = [
    'cancellable',
    'refundable',
    'amendable',
    !isPWA && 'invoice',
    'ticketed'
  ]
  let toolMap = {
    cancellable: {
      icon: Cancel,
      color: '#FF3C2B',
      action: CANCELLATION_TEMPORARILY_DISABLED ? 'show_cancellation_modal' : 'route_out',
      vas: 'freedom_fare',
      text: isPWA ? getMappedValue('Cancel') : getMappedValue('Cancel flights'),
      neg: true,
      href: getCancellationLink(tripId, params)
    },
    refundable: {
      icon: Refund,
      action: 'route_out',
      vas: null,
      text: isPWA ? getMappedValue('Check refund') : getMappedValue('Calculate refund'),
      neg: false,
      href: getCancellationLink(tripId, params)
    },
    amendable: {
      icon: Amend,
      action: 'route_out',
      vas: 'amend_insurance',
      text: isPWA ? getMappedValue('Reschedule') : getMappedValue('Reschedule flights'),
      neg: false,
      href: getAmendmentLink(true, tripId, params)
    },
    ticketed: {
      icon: ETicket,
      action: (isAndroidApp() || isIosApp() || isWebView() || sessionStorage.getItem('mobileApp')) ? 'send_email' : 'download_eticket',
      eText: getMappedValue('E-Ticket'),
      eHref: `/communication/selfcare/api/v2/sendEticket/${tripId}?toEmail=`,
      vas: null,
      text: isPWA ? getMappedValue('E-Ticket') : getMappedValue('Download ticket'),
      neg: false,
      href: `${window.location.origin}/account/trips/${tripId}/documents?docType=eticket&view=${isMobileApp()}`
    },
  }
  if (!isPWA) {
    toolMap = {
      invoice: {
        icon: Invoice,
        action: domain === 'cleartrip.com' ? 'download_invoice' : 'download_view',
        vas: null,
        text: getMappedValue('Download invoice'),
        neg: false,
        href: `${window.location.origin
        }/account/trips/${tripId}/sale_invoice_pdf?view=${isMobileApp()}`
      },
      ...toolMap
    }
  }
  if (vas && vas === 'ezcancel_fare') {
    toolMap.cancellable = {
      icon: Cancel,
      color: '#FF3C2B',
      action: CANCELLATION_TEMPORARILY_DISABLED ? 'show_cancellation_modal' : 'route_out',
      vas: 'ezcancel_fare',
      text: isPWA ? getMappedValue('Cancel') : getMappedValue('Cancel flights'),
      neg: true,
      href: getCancellationLink(tripId, params)
    }
  }
  if (vas && vas === 'ezcancel_fare_pro') {
    toolMap.cancellable = {
      icon: Cancel,
      color: '#FF3C2B',
      action: CANCELLATION_TEMPORARILY_DISABLED ? 'show_cancellation_modal' : 'route_out',
      vas: 'ezcancel_fare_pro',
      text: isPWA ? getMappedValue('Cancel') : getMappedValue('Cancel flights'),
      neg: true,
      href: getCancellationLink(tripId, params)
    }
  }
  const [emailerModal, setEmailerModal] = useState('')
  const [emailerSuccessModal, setEmailerSuccessModal] = useState(false)
  const [showCancellationModal, setShowCancellationModal] = useState(false)

  useEffect(() => {
    const data = vasOpted ?
      Object.keys(vasOpted).reduce((init, item) => {
        let newInit = init
        if (vasOpted[item]) {
          newInit = item
        }
        return newInit
      }, null) :
      null
    setVas(data)
  }, [vasOpted])
  const vasOptedCheck = option => vasOpted &&
    toolMap[option].vas &&
    [false, null, undefined, 'undefined', 'undefined'].indexOf(
      vasOpted[toolMap[option].vas]
    ) === -1
  return (
    <div
      className={`${!isPWA ? 'ba bt-0 mb-5 nmt-2 br-4' : ''} ${vasOpted && vas && !isPWA ? 'pb-2' : ''
      }`}
    >
      <ul
        className={`flex ${isRTL ? 'flex-row-reverse' : ''} ${isPWA ? 'bg-white border-bottom-grey' : 'bg-white-f7 m-3'
        }`}
      >
        {Object.keys(newobj)
          .sort(
            (prev, next) => toolOrder.indexOf(prev.toLowerCase()) -
              toolOrder.indexOf(next.toLowerCase())
          )
          .map(option => (
            <React.Fragment key={`tool_list${Math.random()}--item`}>
              <If
                condition={
                  newobj[option] &&
                  toolMap[option] &&
                  !isOptionHiddenByTemporaryDisable(option) &&
                  (!isInFlyinDomain() ||
                    (isInFlyinDomain() &&
                      option !== 'refundable' &&
                      option !== 'amendable'))
                }
              >
                <ToolItem
                  tripId={tripId}
                  isPWA={isPWA}
                  data={toolMap[option]}
                  isVasOpted={vasOptedCheck(option)}
                  vas={vas}
                  setEmailerModal={setEmailerModal}
                  setEmailerSuccessModal={setEmailerSuccessModal}
                  emailerModal={emailerModal}
                  emailerSuccessModal={emailerSuccessModal}
                  abData={abData}
                  tripDetails={tripDetails}
                  onShowCancellationModal={option === 'cancellable' ? () => setShowCancellationModal(true) : null}
                />
              </If>
            </React.Fragment>
          ))}
      </ul>
      <CancellationBlockModal
        isOpen={showCancellationModal}
        onClose={() => setShowCancellationModal(false)}
        isPWA={isPWA}
      />
    </div>
  )
}

export default ToolList
